import { render, staticRenderFns } from "./InfoHeader.vue?vue&type=template&id=b68176f4&scoped=true&"
import script from "./InfoHeader.vue?vue&type=script&lang=js&"
export * from "./InfoHeader.vue?vue&type=script&lang=js&"
import style0 from "./InfoHeader.vue?vue&type=style&index=0&id=b68176f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68176f4",
  null
  
)

export default component.exports